import { randomUUID } from 'expo-crypto';

export const getUuid = () => randomUUID();
